import { 
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  ViewChild,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { Select } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, combineLatest, Subject } from 'rxjs';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { ViewService } from '../../view.service';
import { MediaModel } from 'src/app/story/models/media.model';
import { ViewUIService } from '../../view-ui.service';
import { ViewUI } from '../../models/view-ui.enum';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentApplication } from 'src/environments/models/environment-application';
import { ViewState } from '../../state/view.state';
import { ViewUIModel } from '../../models/view-ui.model';
import { StoryState } from 'src/app/story/state/story.state';
import { StoryModel } from 'src/app/story/models/story.model';
import { TextUtils } from 'src/app/shared/libraries/text-utils/text-utils';
import { trim } from 'lodash';
import { ViewLayout } from '../../models/view-layout';

@Component({
  selector: 'app-view-description',
  templateUrl: './view-description.component.html',
  styleUrls: ['./view-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewDescriptionComponent implements OnInit, OnDestroy {  
  // ---------- Observables ----------
  @Select(StoryState.getStory)
  story$: Observable<StoryModel>;

  @Select(StoryChaptersState.getSelectedChapter)
  chapter$: Observable<ChapterModel>;

  @Select(StoryChaptersState.getSelectedChapterIndex)
  chapterIndex$: Observable<number>;

  @Select(StoryChaptersState.getChapterCount)
  chapterCount$: Observable<number>;

  @Select(ViewState.getUI)
  layout$: Observable<ViewUIModel>;

  
  // ---------- Class Variables ----------
  viewLayout = ViewUI;
  ngUnsubscribe = new Subject();
  
  storyTitle = '';
  chapterTitle = '';
  chapterDescription = '';
  chapterAudio: MediaModel = null;
  
  // ---------- Input / Output ----------
  @Input()
  layout: ViewLayout = ViewLayout.Drawer;

  @Input()
  public get isPopulated() {
    return this._isPopulated;
  }
  public set isPopulated(value) {
    this._isPopulated = value;
    this.isPopulatedChange.emit(this.isPopulated);
  }
  private _isPopulated = false;

  @Output()
  isPopulatedChange = new EventEmitter<boolean>();
  


  // ---------- Lifecycle ----------
  constructor(
    private viewService: ViewService,
    private layoutService: ViewUIService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initContentListener();
    this.initLayoutListener();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  isEnabled(layout: ViewUI) {
    return this.layoutService.isUIEnabled(layout);
  }
  
  
  
  // ---------- Listeners ----------
  initContentListener() {
    combineLatest(
      this.story$,
      this.chapter$
    ).pipe(
      filter(([story, chapter]) => story != null && chapter != null),
      takeUntil(this.ngUnsubscribe)
    ).subscribe(([story, chapter]) => {
      // Only populate bookmark in web app
      this.storyTitle = (environment.application !== EnvironmentApplication.Viewer) ? TextUtils.normalize(story.displayName) : '';
      this.chapterTitle = TextUtils.normalize(chapter.info.displayName);
      this.chapterDescription = trim(chapter.info.description) ;
      
      this.isPopulated = 
        this.storyTitle !== '' ||
        !!this.chapterTitle || 
        !!this.chapterDescription;
    });
  }

  initLayoutListener() {
    this.layout$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((layout) => {
      this.changeDetectorRef.markForCheck();
    });
  }


  // ---------- Interaction ----------
}
